import {create} from "zustand";

type SessionEndState = {
  sessionEnding: boolean;
  endedReason: string | null;
  setSessionEnding: (value: boolean) => void;
  setEndedReason: (reason: string | null) => void;
  reset: () => void;
};

export const useSessionEndStore = create<SessionEndState>((set) => ({
  sessionEnding: false,
  endedReason: null,
  setSessionEnding: (value) => set({sessionEnding: value}),
  setEndedReason: (reason) => set({endedReason: reason}),
  reset: () => set({sessionEnding: false, endedReason: null}),
}));
